import * as React from 'react';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Check from '@mui/icons-material/Check';
import { StepIconProps } from '@mui/material/StepIcon';
import { LocationData } from '../../../types/location';
import { StepButton } from '@mui/material';
import {RoomConnector, RoomConnectorFreeRoamMode, RoomStepIconRoot} from "./StepProgressBarStyles"  

function RoomStepIcon(props: StepIconProps) {
  const { active, completed, className } = props;

  return (
    <RoomStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <Check className="RoomStepIcon-completedIcon" />
      ) : (
        <div className="RoomStepIcon-circle" />
      )}
    </RoomStepIconRoot>
  );
}

const deriveCurrentStepIndex = (selectedStep: string, locationArray: Array<LocationData>) => {
  return locationArray.map(e => e.value).indexOf(selectedStep);
};

const deriveStepsAndLabels = (locationArray: Array<LocationData>) => {
  return locationArray?.map(locationInfo => { return locationInfo?.value })
}

export interface IStepProgressBar {
  selectedLocation: string;
  locationList: Array<LocationData>;
  freeRoamMode: boolean;
  handleLocationChange: Function;
}

export const StepProgressBar = ({ selectedLocation, locationList, freeRoamMode, handleLocationChange }: IStepProgressBar, ref: any) => {
  const [currentStep, setCurrentStep] = React.useState(deriveCurrentStepIndex(selectedLocation, locationList) | 0);
  const steps = deriveStepsAndLabels(locationList);

  React.useEffect(()=>{
    const newStep = deriveCurrentStepIndex(selectedLocation, locationList);
    if( newStep !== currentStep){
      setCurrentStep(newStep)
    }
  }, [selectedLocation])

  return (
    <Stack sx={{ width: '100%', paddingTop: "10px" }} spacing={4}>
      <Stepper nonLinear={freeRoamMode} alternativeLabel activeStep={currentStep} connector={freeRoamMode ? <RoomConnectorFreeRoamMode /> : <RoomConnector /> }>
        {steps.map((label) => (
          <Step key={label} sx={{
            '& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel':
            {
              color: '#898F8F', // Just text label (COMPLETED)
              fontSize: '0.75rem',
              marginTop: '10px',
            },
            '& .MuiStepLabel-label.MuiStepLabel-alternativeLabel':
            {
              color: '#898F8F', // Just text label (ACTIVE)
              fontSize: '0.75rem',
              marginTop: '10px',
            },
            '& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel':
            {
              color: '#56CCF2', // Just text label  DISABLED)
              fontSize: '0.75rem',
              marginTop: '10px',
            },
          }}>
            
            <StepButton disabled={!freeRoamMode} color="inherit" onClick={()=>{console.log(label, setCurrentStep(deriveCurrentStepIndex(label, locationList)), handleLocationChange(label))}}>
            <StepLabel StepIconComponent={RoomStepIcon}>{label}</StepLabel>
            </StepButton>
          </Step>
        ))}
      </Stepper>
    </Stack>
  );
}
